/**
 * Time helpers. Reykjavík (Atlantic/Reykjavik) is UTC+0 all year with no DST, so local
 * wall-clock time equals UTC. All timestamps are ms since epoch; dates are 'YYYY-MM-DD'.
 */
export const TZ = 'Atlantic/Reykjavik';
export const DAY_MS = 86_400_000;

export function toDateStr(ms: number): string {
  return new Date(ms).toISOString().slice(0, 10);
}

export function parseDateStr(d: string): number {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(d)) throw new Error(`Bad date ${d}`);
  return Date.parse(`${d}T00:00:00Z`);
}

/** 'YYYY-MM-DD' + 'HH:MM' (Reykjavík) → ms */
export function dateTimeToMs(date: string, hhmm: string): number {
  if (!/^\d{2}:\d{2}$/.test(hhmm)) throw new Error(`Bad time ${hhmm}`);
  return Date.parse(`${date}T${hhmm}:00Z`);
}

export function addDays(date: string, n: number): string {
  return toDateStr(parseDateStr(date) + n * DAY_MS);
}

/** ISO weekday 1=Mon..7=Sun */
export function isoWeekday(date: string): number {
  const d = new Date(parseDateStr(date)).getUTCDay();
  return d === 0 ? 7 : d;
}

/** Monday of the ISO week containing `date`. */
export function weekStart(date: string): string {
  return addDays(date, 1 - isoWeekday(date));
}
